import {get} from 'svelte/store';
import {BehaviorSubject, combineLatest} from 'rxjs';
import {filter} from 'rxjs/operators';
import {genSystemDevice} from '@/helper/device';
import {userStatus$} from '@/streams/auth';
import {announcementApi} from '@/api/announcement';
import {mc} from '@/core';
import {lang$} from '@/store';

export const announcements$ = new BehaviorSubject([]);
export const unreadCount$ = new BehaviorSubject(0);
export const importantAnnouncement$ = new BehaviorSubject(null);

const langMap = {
  cn: 'zh',
};

userStatus$.pipe(filter((status) => status !== 'Init')).subscribe((status) => loadAnnouncement(status));

export async function loadAnnouncement(status) {
  const lang = get(lang$);
  let query = {
    itemKey: 'announcement',
    lang: langMap[lang] || lang,
  };
  if (status === 'Logout') {
    query.device = genSystemDevice();
  }
  const {data, error} = await (status === 'Login' ? announcementApi.contentViewLogin(query) : announcementApi.contentViewLogout(query));
  if (data) {
    const {rows, unreadCount} = data;
    announcements$.next(rows);
    unreadCount$.next(unreadCount);
    const importantAnnouncement = rows.find((o) => o.detail.type === 'important-web');
    importantAnnouncement$.next(importantAnnouncement);
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
}
